export function slideDown(element, duration = 200, easing = 'linear') {
  element.style.display = 'block';
  let height = element.scrollHeight;
  element.style.height = '0px';
  element.style.overflow = 'hidden';

  const easingFunctions = {
    linear: function (t) {
      return t;
    },
    easeIn: function (t) {
      return t * t;
    },
    easeOut: function (t) {
      return t * (2 - t);
    },
    easeInOut: function (t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
  };

  let startTime = null;

  function animate(time) {
    if (!startTime) startTime = time;
    let timeElapsed = time - startTime;
    let progress = Math.min(timeElapsed / duration, 1);
    let easeProgress = easingFunctions[easing](progress);

    element.style.height = height * easeProgress + 'px';

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      element.style.height = 'auto';
      element.style.overflow = '';
    }
  }

  requestAnimationFrame(animate);
}

export function slideUp(element, duration = 200, easing = 'linear') {
  let height = element.scrollHeight;
  element.style.height = height + 'px';
  element.style.overflow = 'hidden';

  const easingFunctions = {
    linear: function (t) {
      return t;
    },
    easeIn: function (t) {
      return t * t;
    },
    easeOut: function (t) {
      return t * (2 - t);
    },
    easeInOut: function (t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
  };

  let startTime = null;

  function animate(time) {
    if (!startTime) startTime = time;
    let timeElapsed = time - startTime;
    let progress = Math.min(timeElapsed / duration, 1);
    let easeProgress = easingFunctions[easing](progress);

    element.style.height = height * (1 - easeProgress) + 'px';

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      element.style.display = 'none';
      element.style.height = '';
      element.style.overflow = '';
    }
  }

  requestAnimationFrame(animate);
}
export function updateCurrentSlide(swiper) {
  const sliderEl = swiper.el;
  const container = sliderEl.closest('section');
  if (!container) return;

  const currentElements = container.querySelectorAll('.slider__counter .current');
  currentElements.forEach((el) => {
    const currentIndex = swiper.realIndex + 1;
    el.textContent = currentIndex < 10 ? '0' + currentIndex : currentIndex;
  });
}

/**
 * Watches a specific CSS media query breakpoint and invokes a callback
 * with the current match status (`true` or `false`) whenever the match state changes.
 *
 * @param {string} breakpoint - A valid CSS media query string (e.g., "(max-width: 640px)").
 * @param {(matches: boolean) => void} callback - A function to be called when the media query matches or unmatches.
 *        It receives a boolean indicating the current match state.
 *
 * @example
 * mediaQueryWatcher("(max-width: 768px)", (matches) => {
 *   if (matches) {
 *     console.log("Viewport is 768px or less");
 *   } else {
 *     console.log("Viewport is more than 768px");
 *   }
 * });
 *
 * @note
 * This function performs an immediate check upon initialization and then continues
 * to listen for changes in match state using `matchMedia.addEventListener`.
 */
export function mediaQueryWatcher(breakpoint, callback) {
  const mediaQuery = window.matchMedia(breakpoint);

  const checkWindowSize = () => callback(mediaQuery.matches);

  // Initial check
  checkWindowSize();

  // React to changes
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', checkWindowSize);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(checkWindowSize);
  }
}

export function scrollToEl(linkHREF, setTimeOut = 400) {
  // Determine the target section to scroll to.
  // If linkHREF is already a DOM element, use it directly;
  // otherwise, select it using the provided selector string.
  const anchorSection =
    typeof linkHREF === 'object' ? linkHREF : document.querySelector(`${linkHREF}`);

  // Select the fixed header element and get its height (0 if not found).
  const headerElement = document.querySelector('.header');
  const headerHeight = headerElement ? headerElement.offsetHeight : 0;

  // Select the sub-navigation element (if present) and calculate its height.
  // Add an extra 50px offset only if sub-navigation exists; otherwise, 0.
  const stickySubNav = document.querySelector('.sub-nav');
  const subNavHeight = stickySubNav ? stickySubNav.offsetHeight + 30 : 0;

  // Check if the WordPress admin bar exists and is visible.
  // If yes, get its height; otherwise, set to 0.
  const wpAdminBar = document.getElementById('wpadminbar');
  const wpAdminBarHeight =
    wpAdminBar && wpAdminBar.offsetHeight && wpAdminBar.offsetParent !== null
      ? wpAdminBar.offsetHeight
      : 0;

  // Proceed only if the target anchor section exists on the page.
  if (anchorSection) {
    setTimeout(function () {
      // Calculate the final vertical scroll position:
      // position of the anchor relative to viewport + current scroll position
      // minus the heights of header, sub-navigation, and admin bar.
      const offsetTop =
        anchorSection.getBoundingClientRect().top +
        window.scrollY -
        headerHeight -
        subNavHeight -
        wpAdminBarHeight;

      // Smoothly scroll the window to the calculated position.
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }, setTimeOut);
  }
}
